module.exports = __webpack_public_path__ + "img/logo.2c2bd242.png";